function LatLng(lat, lng) {
    if (lat && typeof lat === 'object') {
        // javascript overloading woo
        return new LatLng(lat.latitude, lat.longitude);
    }

    this.latitude = lat;
    this.longitude = lng;
}

module.exports = LatLng;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/latlng.js
 **/